import React from 'react'

const NotFound = () =>

    <div id="error-msg" className="row justify-content-center align-items-center">
        <div className="col-auto">
            <i className="fas fa-exclamation-triangle fa-4x mb-4 mb-md-0"></i>
        </div>
        <div className="col-auto p-3">
            <h2>La pagina non esiste</h2>
        </div>
    </div>

export default NotFound